import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { GameService } from '../../../../shared/services/game.service';
import { MessageService } from '../../../../shared/services/message.service';
import { NameService } from '../../../../shared/services/name.service';

import { UrlConstants } from '../../../../shared/constants/urlparams.constants';
import { StorageConstants } from '../../../../shared/constants/storage.constants';


@Component({
  selector: 'app-join-game',
  templateUrl: './join-game.component.html',
  styleUrls: ['./join-game.component.scss'],
})

export class JoinGameComponent {
  private get playerName() { return localStorage.getItem("playerName") }

  constructor(private router: Router, private route: ActivatedRoute, private messageService: MessageService, private nameService: NameService, private gameService: GameService) { }

  onSubmit(playerName: string): void {
    this.joinGame(playerName);
  }

  async joinGame(chosenName: string) {
    if (this.nameService.validateName(chosenName)) {
      try {
        let gameID = this.route.snapshot.paramMap.get(UrlConstants.GameID);
        let gameName = this.route.snapshot.paramMap.get(UrlConstants.GameName);
        await this.nameService.saveName(chosenName);

        let playerID = (await this.gameService.registerPlayer()).toString();
        sessionStorage.setItem(StorageConstants.PlayerID, playerID);

        await this.gameService.start();
        await this.gameService.connect();

        this.router.navigate(["game/" + gameID + "/" + gameName]);
      }
      catch (error) {
        this.messageService.showError("Er is iets foutgegaan tijdens het verbinden met het spel, probeer de pagina te herladen");
        this.gameService.disconnect();
      }
    }
    else {
      this.messageService.showWarning(this.nameService.getNameErrors(chosenName));
    }
  }
}
